import { FC, PropsWithChildren } from "react";
import { BuilderBlockProps } from "@/types";
import { Dialog } from "@/components/Dialog";

type DialogBlockProps = {
  isOpen: boolean;
} & BuilderBlockProps;
export const DialogBlock: FC<PropsWithChildren<DialogBlockProps>> = ({
  attributes,
  children,
  isOpen,
}) => {
  return (
    <Dialog show={isOpen ?? false} {...attributes}>
      {children}
    </Dialog>
  );
};
